<template>

    <div class="py-4 container-fluid">
      <div class="row">


        <div class="col-md-8">
          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear Produccion de Modelo</p>
                <argon-button v-if="form.status==0" color="success" size="sm" class="ms-auto"  @click="save"
                  >Guardar</argon-button>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">Información</p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label">Nombre</label>
                  <argon-input type="text"  v-model="form.name"/>
                </div>

                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label">Descripción</label>
                  <ArgonTextarea type="text"  v-model="form.description"/>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Fecha de entrega</label>
                  <argon-input type="date"  v-model="form.delivery_date" />
                </div>

                <div class="col-md-6" v-if="form.id!=0">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <select name="" id="" class="form-select" v-model="form.status" @change="handleStatusChange">>
                    <option value="0" v-if="form.status==0">Pendiente</option>
                    <option value="1" v-if="form.status==0 || form.status==1">Producción</option>
                    <option value="2">Terminado</option>
                    <option value="3">Despachado</option>
                  </select>
                </div>
               
              </div>
            </div>
          </div>

        </div>

        <div class="col-md-4" v-if="form.id!=0" hidden>
          <div class="card mb-2">
            <div class="card-header">
              <div class="d-flex align-items-center">
                <p class="mb-0">Novedades</p>

                <argon-button color="success" size="sm" class="ms-auto" @click="openModal">Agregar</argon-button>
              </div>
              
            </div>
            <div class="card-body">
                
            </div>
          </div>
        </div>

        <div class="col-md-12">


          <div class="card mb-2" v-if="form.id!=0 && form.status>0">

            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="text-uppercase mb-0">Usuarios asignados</p>
                <argon-button color="success" v-if="form.status==1" size="sm" class="ms-auto" @click="openModal"
                  >Asignar usuario</argon-button>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Cant. recibida</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Cant. entregada</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Cant. defectuosa</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Fecha asignado</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Fecha recibido</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Fecha entregado</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Fecha validado</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >observación</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Total ganancia</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  v-for="value in data.data" :key="value.id">
                        <td>
                          <div class="d-flex px-2 py-1">
                            <div class="d-flex flex-column justify-content-center">
                              <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                            </div>
                          </div>
                        </td>
                        <td class="align-middle">
                          <div class="text-secondary text-xs font-weight-bold">
                           Oficio: {{  value?.oficio?.name  }}
                          </div>
                          <div class="text-secondary text-xs font-weight-bold">
                           Talla: {{  value?.model?.size?.size??"Full"  }}
                          </div>
                          <div class="text-secondary text-xs font-weight-bold">
                           Color: {{  value?.model?.size?.color?.name??"Full"  }}
                          </div>
                        </td>
                        <td class="align-middle text-center">
                          {{ value.received_quantity }}
                        </td>
                        <td class="align-middle text-center">
                          {{ value.delivered_quantity }}
                        </td>
                        <td class="align-middle text-center">
                          {{ value.rejected_quantity }}
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            {{ isValidDate(value.assigned_at) ? new Date(value.assigned_at).toLocaleDateString('es-ES') : 'Sin asignar' }}
                          </span>
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            {{ isValidDate(value.received_date) ? new Date(value.received_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                          </span>
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            {{ isValidDate(value.delivered_date) ? new Date(value.delivered_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                          </span>
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            {{ isValidDate(value.validated_date) ? new Date(value.validated_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                          </span>
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                            <a
                              @click="viewObservation(value.observation)" 
                              class="text-secondary font-weight-bold text-xs cursor-pointer" 
                              data-toggle="tooltip"
                              data-original-title="Registro" 
                            >
                            <i class="fa fa-comment"></i>
                          </a>
                          </span>
                        </td>
                        <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                          </span>
                        </td>
                        
                        <td class="align-middle text-center" >
                        <div style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                          <a
                            @click="checkReceived(value)" 
                            class="text-secondary font-weight-bold text-xs cursor-pointer" 
                            data-toggle="tooltip"
                            data-original-title="Registro" 
                            v-if="value.received_date==null"
                          >
                          <i class="fa fa-arrow-down"></i>
                        </a>
                        

                        <a
                            @click="checkDelivered(value)" 
                            class="text-secondary font-weight-bold text-xs cursor-pointer" 
                            data-toggle="tooltip"
                            data-original-title="Eliminar registro" 
                            v-if="( value.received_date!=null && value.delivered_date==null ) || (value.received_date!=null && value.delivered_quantity<value.received_quantity)"
                          >
                          <i class="fa fa-arrow-up"></i>
                        </a>

                        <a
                            @click="checkValidated(value)" 
                            class="text-secondary font-weight-bold text-xs cursor-pointer" 
                            data-toggle="tooltip"
                            data-original-title="Eliminar registro" 
                            v-if="value.delivered_date!=null && value.validated_date==null && value.delivered_quantity>=value.received_quantity"
                          >
                          <i class="fa fa-check"></i>
                        </a>


                          <a
                            @click="deleteUserRegister(value.id)" 
                            class="text-secondary font-weight-bold text-xs cursor-pointer" 
                            data-toggle="tooltip"
                            data-original-title="Eliminar registro" 
                            v-if="value.received_date==null"
                          >
                          <i class="fa fa-trash"></i>
                        </a>
                      </div>
                        </td>
                      </tr>


                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>


          <div class="card" v-if="form.id!=0">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="text-uppercase mb-0">Lista de modelos e insumos</p>
                <argon-button v-if="form.status==0" color="success" size="sm" class="ms-auto" @click="openModalModel"
                >Asignar Modelo</argon-button>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                
                <template v-for="(group, index) in insumos" :key="index">
                  <!-- Tabla para cada talla -->
                  <div class="table-responsive p-0 mb-4">

                    <!-- Encabezado para el grupo (talla) -->
                    <div class="bg-light font-weight-bold rounded p-1 d-flex justify-content-between align-items-center px-2">
                      <div>
                        Modelo: {{ group?.model?.name }} - Talla: {{ group?.size?.size }} - Color: {{ group?.size?.color?.name }} ({{ group?.size?.color?.ref }}) - Cantidad: {{ group?.quantity_to_produce }}
                      </div>
                      <select class="form-select w-20" v-if="form.status!=0" 
                        v-model="group.bodega_id"
                        @change="onBodegaChange(group)"
                      >
                        <option value="" selected>Asignar Bodega</option>
                        <option v-for="(bodega, index) in bodegas"
                        :key="index"
                        :value="bodega.id"
                        >{{ bodega.name }}</option>
                      </select>
                      <a
                        v-if="form.status==0"
                        @click="deleteRegister(group.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip"
                        data-original-title="Eliminar registro"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </div>

                    <div>
                      <span
                        v-for="(oficio, index) in group.oficios"
                        :key="index"
                        :class="['badge', 'badge-sm', 'bg-gradient-' + (oficio.status === 1 ? 'success' : 'primary')]"
                        style="margin-right: 5px;" 
                      >
                        {{ oficio.name }}
                      </span>
                    </div>


                   
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant<span v-if="form.status==0">/stock</span></th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Detalles del grupo -->
                        <tr v-for="detail in group.details" :key="detail.id">
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ detail.inventory.name }} ({{ detail.inventory.ref }})</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center text-sm">
                            {{ detail.quantity }} 
                            <span v-if="form.status==0">/ 
                            <span 
                              class="badge" 
                              :class="{
                                'bg-danger': Number(detail.inventory.quantity || 0) < Number(detail.totalRequired || 0),
                                'bg-secondary': Number(detail.inventory.quantity || 0) >= Number(detail.totalRequired|| 0)
                              }">
                              {{ (Number(detail.inventory.quantity || 0) - Number(detail.totalRequired || 0)).toFixed(2) }}
                              </span>
                            </span>
                          </td>

                          <td class="align-middle text-center text-sm">
                            {{ parseFloat(detail.price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                          </td>
                          <td class="align-middle text-center text-sm">
                            {{ parseFloat(detail.total_price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ new Date(detail.updated_at).toLocaleDateString('es-ES') }} 
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>

              </div>
            </div>
            </div>

        </div>
        
  

      </div>

    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar usuario</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Modelo</label>
                <select v-model="oficio_id" ref="modelUserSelect" id="modelsUser" class="form-select select2" style="width:100%;"  >
                  <option value="0">Producción completa</option>
                  <option v-for="(group) in insumos" :key="group.id" :value="group.id">
                    Modelo: {{ group?.model?.name }} - Talla: {{ group?.size?.size }} - Color: {{ group?.size?.color?.name }} ({{ group?.size?.color?.ref }}) - Cantidad: {{ group?.quantity_to_produce }}
                  </option>
                </select>
              </div>
              
              <div class="mb-3">
                <label for="amount" class="form-label">Oficio</label>
                <select v-model="oficio_id" ref="processesSelect" id="oficio" class="form-select select2" style="width:100%;"  >
                  <option v-for="process in processes" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Usuario</label>
                <select v-model="production_user.user_id" ref="usersSelect" id="users" class="form-select select2" style="width:100%;" >
                 
                  <option v-for="process in filteredUsers" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad asignada</label>
                <input type="text" v-model="production_user.received_quantity" id="amount" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Valor a pagar por unidad</label>
                <input type="text" v-model="formattedTotalUser" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Valor total</label>
                <input type="text" v-model="totalPriceUser" class="form-control" placeholder="Ingrese el valor" readonly>
              </div>
              
              <div class="mb-3">
                <label for="example-text-input" class="form-control-label">Fecha de asignación</label>
                <argon-input type="date" v-model="production_user.assigned_at" />
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>


    
    <!-- Modal Asignar modelo -->
    <div class="modal fade" id="ModalModel" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar Modelo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Modelo</label>
                <select v-model="oficio_id" ref="modelSelect" id="models" class="form-select select2" style="width:100%;"  >
                  <option v-for="process in models" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>


              <div class="mb-3">
                <label for="amount" class="form-label">Talla - Color</label>
                <select v-model="oficio_id" ref="sizesSelect" id="sizes" class="form-select select2" style="width:100%;"  >
                  <option v-for="process in sizes" :key="process.id" :value="process.id">
                    Talla: {{ process.size }} - Color: {{ process.color.name }} ({{ process.color.ref }})
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="production_model.quantity_to_produce" id="amount" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Costo unitario</label>
                <input type="text" v-model="formattedPrice" class="form-control" placeholder="Ingrese el valor" readonly>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Costo total</label>
                <input type="text" v-model="totalPrice" class="form-control" placeholder="Ingrese el valor" readonly>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalModel">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormModel">Guardar</button>
          </div>
        </div>
      </div>
    </div>

  </div>


</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      modalBudget:null,
      modalModel:null,
      oficio_id:null,
      processes:[],
      form: {
        id:0,
        name:'',
        description: '',
        status: 0,
        delivery_date:'',
      },
      size:{
        size:'',
        color_id:'',
        model_id:'',
        quantity:0,
        status:1
      },
      filteredUsers: [],
      bodegas:[],
      models: [],
      insumos:[],
      sizes: [],
      users: [],
      colors: [],
      purchases:[],
      purchase:{
        inventory_id:0,
        quantity:0,
        price:0,
        total_price:0,
        supplier_name:''
      },
      production_user:{
        id:0,
        user_id:0,
        production_models_id:0,
        oficio_id:0,
        production_id:0,
        received_quantity:0,
        delivered_quantity:0,
        price:0,
        assigned_at:'',
      },
      production_model:{
        id:0,
        production_id:0,
        model_id:0,
        size_id:0,
        bodega_id:'',
        quantity_to_produce:0,
        price:0,
      },
      data: {},
      modal: {
        id:0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      modalEvidencia: []
    };
  },
  components: { ArgonInput,ArgonTextarea,ArgonButton },
  computed: {
    formattedTotalUser: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.production_user.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.production_user.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPriceUser() {
      // Calcula el total y aplica el formateo
      const total = this.production_user.received_quantity * this.production_user.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    formattedPrice: {
      get() {
        return this.production_model.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.production_model.price = Math.floor(value.replace(/\./g, "") || 0);
      },
    },
    totalPrice() {
      // Calcula el total y aplica el formateo
      const total = this.production_model.quantity_to_produce * this.production_model.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    
  },
  watch: {
    'form.bodega_id': function () {
      this.handleBodegaChange();
    },
  },
  methods: {
    async onBodegaChange(data) {

      await this.$store.dispatch('productionModels/save',data); 

      await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'Bodega asignada',
          confirmButtonText: 'Aceptar',
          backdrop: true,
      });
      
    },
    async handleStatusChange() {
      if (this.form.status === '1') {
        const result = await Swal.fire({
          title: 'Confirmar cambio de estado',
          text: 'Al cambiar a estado producción, los insumos se restarán de las existencias. Verifica que tengas los insumos necesarios.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, confirmar',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          this.handleStatusChangeSave(); 
          this.getInsumos();
        }else{
          this.form.status = 0;
        }
      }else{
        this.handleStatusChangeSave(); 
      }

    },
    async handleStatusChangeSave() {
      const response = await this.$store.dispatch("production/save", this.form);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El estado cambio correctamente',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          });
      }else{
        await Swal.fire({
              icon: 'error',
              title: '¡Insumos insufiecientes!',
              text: 'Verifica la cantidad y stock disponible en la tabla de insumos.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          });

          if (this.form.status === '1') {
            this.form.status = 0;
          }


      }
    },
    async handleBodegaChange() {
       await this.$store.dispatch("production/save", this.form);
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll'); 
    },
    async getOficios() {
      this.processes =  await this.$store.dispatch('users/getOficios'); 
    },
    filterUsersByOficio() {
      if (this.oficio_id!=0) {
        this.filteredUsers = this.users.filter(user => {
          // Asegúrate de que processes sea un arreglo
          const processes = Array.isArray(user.processes)
            ? user.processes
            : JSON.parse(user.processes || "[]");
          return processes.map(Number).includes(Number(this.oficio_id));
        });
      } else {
        this.filteredUsers = []; // Mostrar todos los usuarios si no hay oficio seleccionado
      }
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async getModels() {
      this.models = await this.$store.dispatch('models/getAll'); 
    },
    async getSizes() {
      let tallas = await this.$store.dispatch('sizes/getData',this.production_model.model_id); 
      this.sizes = tallas.data;
    },
    async getUsers() {
      await this.$store.dispatch('users/fetchUsers'); 
      this.users =this.$store.state.users.users;
    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    openModalModel() {
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement); // Guarda la instancia del modal
      this.modalModel.show(); // Muestra el modal
    },
    closeModalModel() {
      if (this.modalModel) {
        this.modalModel.hide(); // Cierra el modal
      }
    },
    async getData() {
      await this.$store.dispatch('productionUsers/getData',this.form.id); 
      this.data =this.$store.state.productionUsers.getData;
    },
    async getInsumos() {
      await this.$store.dispatch('productionModels/getData',this.form.id); 
      this.insumos = this.$store.state.productionModels.getData;
    },
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("production/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {

                this.form = response.data;
                this.form.id = response.data.id || 0;
                this.modal.project_id = response.data.id || 0;

                this.production_model.production_id = response.data.id || 0;
                this.production_user.production_id = response.data.id || 0;

                this.getInsumos();
                this.getModels();
                this.getOficios();
                this.getBodegas();
                this.getSizes();
                this.getUsers();
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },  
    async submitForm() {
      try {
        this.production_user.oficio_id = this.oficio_id;
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionUsers/save", this.production_user);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getData();
                this.getInsumos();
                this.closeModal();

                this.production_user.production_models_id = 0;
                this.production_user.oficio_id = 0;
                this.production_user.user_id = 0;
                this.production_user.received_quantity = 0;
                this.production_user.price = 0;
                this.production_user.delivered_quantity = 0;
                

                $(this.$refs.modelUserSelect).val(null).trigger('change');
                $(this.$refs.processesSelect).val(null).trigger('change');
                $(this.$refs.usersSelect).val(null).trigger('change');
                
              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    
    },
    async submitFormModel() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionModels/save", this.production_model);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {

                this.production_model.model_id=0;
                this.production_model.size_id=0;
                this.production_model.quantity_to_produce=0;
                this.production_model.price=0;

                $(this.$refs.modelSelect).val(null).trigger('change');
                $(this.$refs.sizesSelect).val(null).trigger('change');


                this.getInsumos();
                this.closeModalModel();


              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionModels/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Recibir Tarea',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          value.received_date = new Date().toISOString().slice(0, 10);

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Tarea aceptada!',
              'Recuerda realizar la entrega.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async checkDelivered(value) {
      try {
        const { value: formValues } = await Swal.fire({
          title: 'Entregar Tarea',
          html: `
          <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Cantidad entregada:</label>
                <input id="swal-input-cant" type="number" class="form-control" placeholder="Cantidad entregada" min="1">
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          preConfirm: () => {
            const cant = document.getElementById('swal-input-cant').value;
            const obs = document.getElementById('swal-input-obs').value;

            if (!cant || isNaN(cant) || cant <= 0) {
              Swal.showValidationMessage('Debe ingresar una cantidad válida.');
              return;
            }

            return { cant: parseInt(cant, 10), obs };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          value.delivered_date = new Date().toISOString().slice(0, 10);
          value.delivered_quantity = formValues.cant;
          value.observation = formValues.obs;

          const response = await this.$store.dispatch("productionUsers/save", value);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea Entregada!',
              'Excelente trabajo.',
              'success'
            );
            this.getData();
          } else {
            this.getData();
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);

    
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });

       
        
      }
    },
    async checkValidated(value) {
      try {
        const { value: cant } = await Swal.fire({
          title: 'Validar Tarea',
          html: `
            <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos:</label>
                <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0">
              </div>
            </div>
          `,
          focusConfirm: false,
          preConfirm: () => {
            const defectInput = document.getElementById('swal-input-defect').value;

            if (!defectInput || isNaN(defectInput) || defectInput < 0) {
              Swal.showValidationMessage('Debe ingresar una cantidad válida.');
              return false;
            }
            return defectInput;
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (cant) {

          value.validated_date = new Date().toISOString().slice(0, 10);
          value.rejected_quantity = cant;
          value.finish = 1;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Tarea Validada!',
              'Excelente trabajo.',
              'success'
            );

            this.getData();
          } else {
            this.getData();
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteUserRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
  
  },
  mounted() {

    // Continuamos con la lógica posterior a la carga de datos
    const route = useRoute();
    const dataEdit = route.params.data;
    // Mostrar el modal de "Cargando"
   
    (async () => {
      // Mostrar el modal de "Cargando"
      Swal.fire({
        icon: 'info',
        title: 'Cargando...',
        text: 'Estamos obteniendo los datos, por favor espera.',
        didOpen: () => {
          Swal.showLoading();
        },
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

      try {
        // Si hay datos para editar, cargarlos
        if (dataEdit) {

          const params = JSON.parse(dataEdit);
          this.data = params;
          if (params && params.id) {
            this.purchase.inventory_id = params.id || 0;
            this.size.model_id = params.id || 0;
            this.production_user.production_id = params.id || 0;
            this.production_model.production_id = params.id || 0;

            this.form.id = params.id || 0;
            this.form.name = params.name || '';
            this.form.description = params.description || '';
            this.form.status = params.status || 0;
            this.form.delivery_date = params.delivery_date || '';
            this.modal.project_id = params.id || 0;
 
            await this.getData();
            await this.getUsers();
          }

          // Realizar las solicitudes de datos de forma asíncrona
          await Promise.all([
            this.getModels(),
            this.getOficios(),
            this.getBodegas(),
            this.getSizes(),
          ]);

          // Obtener datos adicionales
          await this.getData();
          await this.getInsumos();
        }


        // Configurar select2 una vez que los datos estén cargados
        this.$nextTick(() => {
          $(this.$refs.modelSelect).select2({
            placeholder: 'Seleccione un modelo',
            allowClear: false,
            dropdownParent: $('#ModalModel .modal-body'),
          }).on('change', () => {
            this.production_model.model_id = $(this.$refs.modelSelect).val();
            const selectedModel = this.models.find(model => model.id == this.production_model.model_id);
            this.production_model.price = selectedModel ? Math.floor(selectedModel.price) : 0;
            this.getSizes();
          });

          $(this.$refs.modelUserSelect).select2({
            placeholder: 'Seleccione un modelo',
            allowClear: false,
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', () => {
            this.production_user.production_models_id = $(this.$refs.modelUserSelect).val();
          });

          $(this.$refs.sizesSelect).select2({
            placeholder: 'Seleccione una talla',
            allowClear: false,
            dropdownParent: $('#ModalModel .modal-body'),
          }).on('change', () => {
            this.production_model.size_id = $(this.$refs.sizesSelect).val();
            this.getSizes();
          });

          $(this.$refs.usersSelect).select2({
            placeholder: 'Seleccione un usuario',
            allowClear: false,
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', () => {
            this.production_user.user_id = $(this.$refs.usersSelect).val();
          });

          $(this.$refs.processesSelect).select2({
            placeholder: 'Filtrar por oficio',
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', (event) => {
            this.oficio_id = $(event.target).val();
            this.filterUsersByOficio();
          });
        });


        // Cerrar el modal de carga
        Swal.close();
      } catch (error) {
        // Manejo de errores
        console.error("Error al cargar los datos:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al cargar los datos. Por favor, inténtalo nuevamente.',
        });
      }
    })();


    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none; /* Impide la interacción */
  cursor: not-allowed; /* Cambia el cursor para indicar que está deshabilitado */
}
</style>


